// extracted by mini-css-extract-plugin
export var items = "navigation-module--items--xGMxK";
export var item = "navigation-module--item--re9lJ";
export var active = "navigation-module--active--+8QS+";
export var fadein = "navigation-module--fadein--y+7Sx";